import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ref } from '@dbk-legacy/muster/utils';
import { createContainer } from '@dbk-legacy/muster/react';
import BackLink from '../../../common/back-link';
import { DBLogo } from '@dbk/ui-icons';
import Button from '@dbk/ui-buttons';
import Text from '@dbk/ui-text';
import Separator from '../../../common/separator';
import { SeparatorFullWidth } from '../../../common/separator/separator.styles';
import envConfig from '../../../../../db-env-build';

class TitleHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMobileChecked: 'small-8 columns text-center',
      isDisabled: false,
    };
  }

  componentDidMount() {
    const { ui } = this.props;
    if (
      ui.history.currentLocation.pathname ===
      `/${envConfig.envConfig}/admin/alertmanagement`
    ) {
      this.setState({
        isDisabled: false,
        isMobileChecked: 'small-12 columns text-center',
      });
    } else {
      this.setState({
        isDisabled: true,
        isMobileChecked: 'small-8 columns text-center',
      });
    }
  }

  handleCreateNewPress() {
    this.props.replacePage({ pathname: '/admin/alertmanagement' });
    // this.props.changePage({pathname:'/admin/alertmanagement'}, true);
  }

  render() {
    const {
      ui,
      i18n: { messages },
    } = this.props;
    return (
      <div className="title-Header">
        <DBLogo />
        <div className="row margin-top-50">
          {this.state.isDisabled && (
            <div className="small-2 columns">
              <BackLink messages={messages} />
              <span>&nbsp;</span>
            </div>
          )}
          <div className={this.state.isMobileChecked}>
            <div id={ui.customtitle || ui.title} className="section-title">
              <Text secondary>{messages[ui.customtitle || ui.title]}</Text>
            </div>
          </div>
          {this.state.isDisabled && (
            <div className="small-2 columns">
              <Button
                id="createNew"
                size="small"
                onClick={() => this.handleCreateNewPress()}
              >
                {messages['app.common.title.createNew']}
              </Button>
            </div>
          )}
        </div>
        <div>
          <Separator separator={SeparatorFullWidth.separator} />
        </div>
      </div>
    );
  }
}

TitleHeader.propTypes = {
  title: PropTypes.string,
  changePage: PropTypes.func,
  replacePage: PropTypes.func,
  ui: PropTypes.shape({
    customtitle: PropTypes.string,
  }),
};

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    replacePage: { $call: 'ui.history.replace' },
    ui: {
      setDebug: { $set: 'debug' },
      title: true,
      customtitle: true,
      history: {
        currentLocation: {
          pathname: true,
        },
      },
    },
    i18n: {
      messages: true,
    },
    callback: {
      screen: true,
      setScreen: { $call: 'setScreen' },
    },
  },
  $renderError: () => null,
})(TitleHeader);
